import Link from 'next/link';
import type { ReactNode } from 'react';

import * as S from './style';

interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  target?: string;
}

export function Button({ children, onClick, href, target }: ButtonProps) {
  if (href) {
    return (
      <Link
        href={href}
        target={target}
        onClick={onClick}
        style={{
          textDecoration: 'none',
          width: '100%',
          display: 'block',
        }}
      >
        <S.Wrapper>{children}</S.Wrapper>
      </Link>
    );
  }

  return <S.Wrapper onClick={onClick}>{children}</S.Wrapper>;
}
